import { render, staticRenderFns } from "./widgetBright.vue?vue&type=template&id=7c02cddb&scoped=true&"
import script from "./widgetBright.vue?vue&type=script&lang=js&"
export * from "./widgetBright.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c02cddb",
  null
  
)

export default component.exports